import { useDefaultAssessmentPrompt } from "../../../hooks/useDefaultAssessmentPrompt";

type DefaultAssessmentPromptPrefetchProps = Readonly<{
  conceptCode: string;
  objectType?: string;
  objectSubType?: string;
}>;

/** Prefetches default prompt when concept is selected, before the field is shown. */
export default function DefaultAssessmentPromptPrefetch({
  conceptCode,
  objectType,
  objectSubType,
}: DefaultAssessmentPromptPrefetchProps) {
  useDefaultAssessmentPrompt(conceptCode, {
    targetType: objectType,
    subType: objectSubType,
  });
  return null;
}
